/* eslint-disable */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicAssetsUsersDevicesIcon extends BaseIcon {
  getChildren = () => [
  <g transform="translate(-681 -200.687)">
    <path d="M7.034,18.586v1.759h8.448a.707.707,0,0,0,.153-.422,4.213,4.213,0,0,1-.737-1.337H12.31V16.827h1.628a5,5,0,0,1-.188-1.022l-.005-.067v-.067a3.176,3.176,0,0,1,.084-.6H3.517A1.661,1.661,0,0,1,1.759,13.31V4.517A1.661,1.661,0,0,1,3.517,2.759H19.345A1.661,1.661,0,0,1,21.1,4.517V8.295a5.368,5.368,0,0,1,1.759.835V2.759A1.661,1.661,0,0,0,21.1,1H1.759A1.661,1.661,0,0,0,0,2.759v12.31a1.661,1.661,0,0,0,1.759,1.759h8.793v1.759Z" transform="translate(681 199.687)" fill={ this.getColor() } fillRule="evenodd"/>
    <path d="M19.8,19.123c-2.325-.872-3.058-1.618-3.058-3.2,0-.948.707-.631,1.024-2.376.127-.721.746,0,.885-1.669,0-.658-.341-.823-.341-.823s.165-.973.241-1.718S18.015,6,14.756,6s-3.8,2.415-3.8,3.338a6.675,6.675,0,0,0,.241,1.718s-.241.165-.241.823c.127,1.657.746.936.885,1.669.306,1.732,1.011,1.428,1.011,2.376,0,1.593-.733,2.341-3.058,3.211S6,20.906,6,21.513v2.073H23.586V21.513C23.586,20.906,22.07,20.009,19.8,19.123Z" transform="translate(685.552 203.48)" fill={ this.getColor() }/>
  </g>
 ]
  getViewBox = () => '0 0 28.138 26.379'
}
